import { styled } from 'baseui';

export const PageContainer = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  backgroundColor: $theme.colors.backgroundPrimary,
  overflow: 'hidden',
}));

export const Sidebar = styled('nav', ({ $theme }) => ({
  width: '280px',
  flexShrink: 0,
  backgroundColor: $theme.colors.backgroundSecondary,
  borderRight: `1px solid ${$theme.colors.borderOpaque}`,
  display: 'none',
  flexDirection: 'column',
  padding: $theme.sizing.scale800,
  overflowY: 'auto',
  [`@media screen and (min-width: ${$theme.breakpoints.large}px)`]: {
    display: 'flex',
  },
}));

export const MainContent = styled('div', ({ $theme }) => ({
  flex: 1,
  overflowY: 'auto',
  padding: $theme.sizing.scale800,
  boxSizing: 'border-box',
  scrollBehavior: 'smooth',
}));

export const SectionContainer = styled('section', ({ $theme }) => ({
  marginBottom: $theme.sizing.scale1200,
  maxWidth: '800px',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
}));

export const FloatingMenuButton = styled('div', ({ $theme }) => ({
  position: 'fixed',
  bottom: $theme.sizing.scale800,
  right: $theme.sizing.scale800,
  display: 'flex',
  [`@media screen and (min-width: ${$theme.breakpoints.large}px)`]: {
    display: 'none',
  },
  zIndex: 10,
}));

export const NavItem = styled('button', ({ $theme, $active }) => ({
  display: 'block',
  width: '100%',
  textAlign: 'left',
  padding: `${$theme.sizing.scale400} ${$theme.sizing.scale600}`,
  marginBottom: $theme.sizing.scale200,
  backgroundColor: $active ? $theme.colors.backgroundTertiary : 'transparent',
  border: 'none',
  borderRadius: $theme.borders.radius300,
  color: $active ? $theme.colors.contentPrimary : $theme.colors.contentSecondary,
  cursor: 'pointer',
  fontSize: $theme.sizing.scale600,
  transition: 'all 0.2s ease',
  ':hover': {
    backgroundColor: $theme.colors.backgroundTertiary,
    color: $theme.colors.contentPrimary,
  },
}));

export const ScreenshotImage = styled('img', ({ $theme, $width }) => ({
  width: $width || '100%',
  maxWidth: '100%',
  borderRadius: $theme.borders.radius400,
  border: `1px solid ${$theme.colors.borderOpaque}`,
  marginTop: $theme.sizing.scale600,
  marginBottom: $theme.sizing.scale600,
  boxShadow: $theme.lighting.shadow400,
}));

export const IconWrapper = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: 'middle',
  margin: '0 4px',
});

export const AccordionWrapper = styled('div', ({ $theme }) => ({
  marginTop: $theme.sizing.scale600,
  marginBottom: $theme.sizing.scale600,
}));

export const accordionOverrides = {
  Header: {
    style: ({ $theme }) => ({
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: $theme.sizing.scale400,
      paddingBottom: $theme.sizing.scale400,
      borderBottomWidth: '1px',
      backgroundColor: 'transparent',
    }),
  },
  Content: {
    style: ({ $theme }) => ({
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: $theme.sizing.scale400,
      paddingBottom: $theme.sizing.scale400,
      backgroundColor: 'transparent',
    }),
  },
};
